export const DEFAULTS = {}

export const COLORS = {
    primary: {
        font: "#eceff1",
        main: "#2F4A4E",
        error: "#9a0d00ff",
        light: "rgba(108, 133, 137, 1)",
        acept: "#99b83c",
        background: "#rgba(146, 171, 175, 1)",
        fondoItem: "#f4edff",
        shadowBox: "0px 4px 4px 0px rgba(131, 72, 255, 0.1)"
    },
};